export default {
    "meta": {
        "title": "How to Choose Between a Cloud-Based and Local Trading Bot?",
        "description": "Explore the key differences between cloud-based and local trading bots to determine which hosting solution best suits your needs."
    },
    "hero": {
        "notification": "Find your ideal bot hosting solution",
        "h1": "How to Choose Between a Cloud-Based and Local Trading Bot?",
        "paragraph1": "Choosing between cloud-based and local bots can have a major impact on performance, security, and flexibility. Both hosting methods have their pros and cons, and the right choice depends on your trading style and priorities.",
        "paragraph2": "Let's explore the key considerations when selecting between a cloud-based or locally hosted trading bot. Whether you value control, speed, or convenience, understanding the benefits of each type will help you make an good decision. We'll also touch on how Gunbot provides a flexible option for traders who want the best of both worlds—high customization and powerful local control.",
        "chartSymbol": "BTC/USD",
        "chartFeatures": [
            { 
                "id": 1, 
                "title": "Real-time Execution", 
                "description": "See the immediate execution of trades, especially when using local bots that eliminate cloud latency." 
            },
            { 
                "id": 2, 
                "title": "Multiple Timeframe Analysis", 
                "description": "Local bots offer great flexibility in monitoring various timeframes and executing strategies with precision." 
            }
        ],
        "reviewHeading": "Gunbot Users Share Their Experiences"
    },
    "block1": {
        "heading": "Cloud-Based vs. Local Trading Bots: What's the Difference?",
        "paragraph": "The primary difference between cloud-based and local trading bots lies in where the bot is hosted. Cloud-based bots operate on remote servers managed by a third party, offering convenience and the ability to run 24/7 without needing your computer to stay online. However, this comes with some trade-offs, such as limited customization and potentially slower execution speeds due to internet latency. On the other hand, local trading bots, like Gunbot, run directly on your computer or server. This allows traders full control over their bot, ensuring privacy, faster execution, and the ability to customize strategies in-depth. While local bots may require more technical knowledge to set up and maintain, they offer significant advantages for serious traders.",
        "imgAlt": "A dashboard comparing cloud-based and local trading bot performance.",
        "featureTitle1": "Cloud Convenience",
        "featureDescription1": "Cloud-based bots offer 24/7 uptime and are easy to set up, making them ideal for users who prefer a hands-off approach.",
        "featureTitle2": "Local Control",
        "featureDescription2": "Local bots provide unmatched control over your strategies, execution speed, and privacy, as all data stays on your machine.",
        "featureTitle3": "Customization",
        "featureDescription3": "Local bots like Gunbot allow for highly detailed strategy customization, including the ability to use custom scripts and fine-tune performance.",
        "featureTitle4": "Security & Privacy",
        "featureDescription4": "With local bots, your API keys and trading data remain on your own server, ensuring the highest level of security and privacy."
    },  
    "quote": {
        "paragraph": "“Running Gunbot locally gave me total control over my trading strategies and execution speed, something I couldn't achieve with cloud-based bots.”"
    },
    "resources": {
        "heading": "Dive Deeper into Trading Bots",
        "subheading": "Expand your knowledge of bot hosting options",
        "description": "Explore these resources to get a more detailed understanding of how Gunbot and other bots operate in both local and cloud-based environments.",
        "resources": [
            {
                "title": "Supported Exchanges for Gunbot",
                "description": "See which exchanges are compatible with Gunbot and how you can set up your bot to trade across multiple platforms.",
                "link": "https://www.gunbot.com/exchanges/",
                "linkText": "Learn More"
            },
            {
                "title": "Gunbot on a VPS: Linux Setup Guide",
                "description": "Set up Gunbot on a Linux VPS for a remote but fully controlled trading environment with PM2.",
                "link": "https://www.gunbot.com/blog/run-gunbot-linux-vps-pm2-guide/",
                "linkText": "Read More"
            },
            {
                "title": "Understanding Timeframes and Order Types",
                "description": "A comprehensive guide to trading timeframes and order types available in Gunbot.",
                "link": "https://www.gunbot.com/support/guides/trading-logic-and-optimization/timeframes-order-types-explained/",
                "linkText": "Explore"
            },
            {
                "title": "Customizing Your Trading Strategy with Gunbot",
                "description": "Discover the full range of customization options available to Gunbot users, from JavaScript strategies to advanced parameters.",
                "link": "https://www.gunbot.com/support/docs/custom-strategies/what-are-custom-strategies/",
                "linkText": "Check it Out"
            }
        ]
    },
    "block2": {
        "heading": "Why Local Bots Like Gunbot Stand Out",
        "paragraph": "Local trading bots, such as Gunbot, offer a level of flexibility and control that cloud-based solutions simply can't match. By running the bot on your own machine, you can optimize strategies without worrying about third-party servers or delays caused by internet latency. For traders who need fast, real-time responses to market changes, this is a significant advantage. Additionally, the ability to store your API keys and trading data locally means enhanced privacy and security. Another major benefit of a local setup is the deep customization potential. Gunbot allows traders to write custom strategies, adjust every aspect of the bot's behavior, and even run multiple instances for different markets—all on the same machine. While cloud-based bots are convenient, they often lack the advanced features that more seasoned traders crave. Gunbot strikes a perfect balance by providing the tools for highly detailed, hands-on trading, all while keeping you in control.",
        "imgAlt": "A trading chart showing precise strategy execution on a local bot."
    },
    "cta": {
        "text": "Still unsure about which bot hosting option is right for you?",
        "linkText": "Contact us for advice",
        "link": "https://www.gunbot.com/contact/",
        "linkTitle": "Get expert advice on bot hosting"
    },
    "pricing": {
        "heading": "Choose Your Gunbot Plan",
        "primaryButtonText": "I want this!",
        "yearlyAdmonition": "-50%",
        "lifetimeAdmonition": "Best value",
        "tabs": { 
            "Monthly": [],
            "Annual": [],
            "Lifetime": []
        },
        
        
        "joinGunbotCommunity": "Join Gunbot community",
        "moreDetailsAbout": "More details about"
    }
}
